import React from "react";

// Slim dot indicator — the app's desktop step headers assume far more width than a phone has.
const SetupProgress = ({ current, total }) => (
  <div className="flex items-center justify-center gap-2">
    {Array.from({ length: total }, (_, i) => (
      <span
        key={i}
        className={`h-1.5 rounded-full transition-all duration-200 ${
          i === current
            ? "w-6 bg-gradient-to-r from-pink-500 to-blue-500"
            : i < current
            ? "w-1.5 bg-pink-400/60"
            : "w-1.5 bg-gray-700"
        }`}
      />
    ))}
  </div>
);

export default SetupProgress;
